import { Component } from '@angular/core';

@Component({
  selector: 'uni-layout-logged',
  styleUrls: ['./uni-layout-logged.component.scss'],
  templateUrl: './uni-layout-logged.component.html',
})
export class UniLayoutLoggedComponent { }
